import React, { useEffect, useState } from "react";
import FormikController from "../../../components/FormikController/FormikController";
import { nurseVisitType } from "../../../Constants/Constants";
import {
  FormControlLabel,
  Grid,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ClientStore from "../../../Store/ClientStore";
import { format } from "date-fns";
import { headerTextStyles, centerTextStyles } from "../../../Constants/Styles";
import {
  additional,
  instrumentalActivities,
  attendant,
  dailyActivity,
  communication,
  financialProfile,
  socialProfile,
  nursingAsessMedicalInfo,
  livingHabit,
  systemAssessment,
} from "../../../Constants/FileData";
import ConfirmPopUp from "../../../components/ConfirmPopUp/ConfirmPopUp";
import { useFormik } from "formik";
import { YupValidation } from "../../../Constants/ValidationConstants";
import * as Yup from "yup";
import { nurseCGRelation } from "../../../Utils/PdfFileUtils";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ClientURL } from "../../../Url/Url";
import AgencyStore from "../../../Store/AgencyStore";

export const AddNursingAssessment = ({ handleClose, type }) => {
  const { clientId } = useParams();
  const [medicalInfo, setMedicalInfo] = useState(nursingAsessMedicalInfo);
  const [additionalInfo, setAdditionalInfo] = useState(additional);
  const [financialInfo, setFinancialInfo] = useState(financialProfile);
  const [socialInfo, setSocialInfo] = useState(socialProfile);
  const [attendantInfo, setAttendantInfo] = useState(attendant);
  const [instrumentalInfo, setInstrumentalInfo] = useState(
    instrumentalActivities
  );
  const [livingInfo, setLivingInfo] = useState(livingHabit);
  const [dailyInfo, setDailyInfo] = useState(dailyActivity);
  const [systemAssessInfo, setSystemAssessInfo] = useState(systemAssessment);

  const [saveUpadateState, setSaveUpadateState] = useState("");

  const handlesaveUpadateState = (value) => {
    setSaveUpadateState(value);
  };
  const [communications, setCommunication] = useState(communication);
  const [selectedValues, setSelectedValues] = useState({
    spokenLanguage: [],
    underStandableSpeech: [],
    method: [],
    phrases: [],
    financialBenefits: [],
    financialMgmt: [],
    housing: [],
    livingCompanion: [],
    attendant: [],
    frequency: [],
    attendantMeetBy: [],
    prepareFood: [],
    housekeeping: [],
    shopping: [],
    transportation: [],
    telephone: [],
    medication: [],
    currentDiet: [],
    mobility: [],
    ambulation: [],
    independent: [],
    supervisionTransferring: [],
    intermittentTransferring: [],
    continuedAssistance: [],
    bathing: [],
    minorSupervision: [],
    independents: [],
    supervision: [],
    dailyHelp: [],
    grooming: [],
    assistance: [],
    eating: [],
    intermittent: [],
    bladder: [],
    bowelControl: [],
    toileting: [],
    exercisesRegularly: [],
    recentChangesToExercise: [],
    pulse: [],
    bp: [],
    orientation: [],
    pupils: [],
    grip: [],
    skin: [],
    oralMembranes: [],
    edema: [],
    peripheral: [],
    respiratory: [],
    musculoskeletal: [],
    abdomen: [],
    genitourinary: [],
    pain: [],
    dentalState: [],
    vision: [],
    hearing: [],
    useHearing: [],
    pyschosocial: [],
    attitude: [],
    appearance: [],
    selfDirection: [],
    behavior: [],
    influence: [],
    thoughtContent: [],
    perceptions: [],
    cognition: [],
    insight: [],
    judgment: [],
  });
  const [selectOption, setSelectOption] = useState({
    approx: [],
    clientSmoke: [],
    degreeOfProblem: [],
    clientDrink: [],
    degreeOfProblemAlcohol: [],
    eating: [],
    wheelChair: [],
    dentalProblems: [],
    underCaredentist: [],
    chewfood: [],
    wearGlasses: [],
  });

  const handleRadioChange = (name, value) => {
    let radioValue = [value];
    setSelectOption((prevState) => ({
      ...prevState,
      [name]: radioValue,
    }));
  };

  const handleCheckboxChange = (type, value) => {
    setSelectedValues((prevState) => {
      const updatedSelectedValues = { ...prevState };
      const currentSelections = updatedSelectedValues[type];
      if (currentSelections.includes(value)) {
        updatedSelectedValues[type] = currentSelections.filter(
          (item) => item !== value
        );
      } else {
        updatedSelectedValues[type] = [...currentSelections, value];
      }
      return updatedSelectedValues;
    });
  };

  const handleTextChange = (generalTopic, subIndex, key, value, setter) => {
    setter((prevState) => {
      const updateInfo = prevState.map((item) => {
        if (item.generalTopic === generalTopic) {
          const updatedSubjectMatter = Array.isArray(item?.subjectMatter)
            ? item.subjectMatter.map((subject, index) => {
                if (index === subIndex && key !== "actionIndicated") {
                  subject[key] = value;
                }
                return subject;
              })
            : item?.subjectMatter;

          return {
            ...item,
            actionIndicated:
              key === "actionIndicated" ? value : item.actionIndicated,
            subjectMatter: updatedSubjectMatter,
          };
        }
        return item;
      });
      return updateInfo;
    });
  };

  const formik = useFormik({
    initialValues: {
      relationRN: "",

      visitType: "",
      doctorName: "",
      doctorPhoneNo: "",
      contactPerson: "",
      contactPhoneNo: "",
    },
    validationSchema: Yup.object({
      relationRN: YupValidation.requiredOnly,
      visitType: YupValidation.requiredOnly,
      doctorName: YupValidation.requiredOnly,
      doctorPhoneNo: YupValidation.requiredOnly,
      contactPerson: YupValidation.requiredOnly,
      contactPhoneNo: YupValidation.requiredOnly,
    }),

    onSubmit: (values) => {
      if (saveUpadateState == "save") {
        saveNursingAssessment(values);
      }
      //  updateCareEvaluationForm(values);
    },
  });
  const [relationRN, setRelationRN] = useState([]);

  useEffect(() => {
    const [nurseData, careGiverData] = nurseCGRelation();
    setRelationRN(nurseData);
  }, []);

  const handleChange = (id, value, field, setter) => {
    setter((prevState) =>
      prevState.map((item, index) => {
        if (index === id) {
          return {
            ...item,
            generalTopic: field === "generalTopic" ? value : item.generalTopic,
            subjectMatter:
              field === "subjectMatter" ? value : item.subjectMatter,
            actionIndicated:
              field === "actionIndicated" ? value : item.actionIndicated,
          };
        }
        return item;
      })
    );
  };
  const handleInfo = (setter) => {
    return setter?.map((item, index) => {
      const updatedItem = { ...item };
      if (Array.isArray(updatedItem?.subjectMatter)) {
        updatedItem?.subjectMatter?.forEach((subject) => {
          Object.keys(subject).forEach((key) => {
            if (selectedValues[key]?.length > 0) {
              subject[key] = selectedValues[key];
            } else if (selectOption[key]?.length > 0) {
              subject[key] = selectOption[key];
            }
          });
        });
      }
      return updatedItem;
    });
  };

  const saveNursingAssessment = (values) => {
    const updateCommunication = handleInfo(communications);
    const updateFinancialInfo = handleInfo(financialInfo);
    const updateSocialInfo = handleInfo(socialInfo);
    const updateAttendantInfo = handleInfo(attendantInfo);
    const updateInstrumentalInfo = handleInfo(instrumentalInfo);

    const updateLivingInfo = handleInfo(livingInfo);
    const updateActivityInfo = handleInfo(dailyInfo);
    const updateSystemInfo = handleInfo(systemAssessInfo);
    AgencyStore.setIsLoading(true);
    const params = {
      clientId: clientId,
      rnId: values.relationRN,
      visitType: values.visitType,
      doctorName: values.doctorName,
      doctorPhoneNo: values.doctorPhoneNo,
      contactPerson: values.contactPerson,
      contactPhoneNo: values.contactPhoneNo,
      nursingAssessmentDate: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
      medicalInformation: medicalInfo,
      personalCareAidePhone: ClientStore?.ClientAllData?.client?.phoneNo,
      systemAssessment: updateSystemInfo,
      livingHabits: updateLivingInfo,
      communication: updateCommunication,
      activityOfDailyLiving: updateActivityInfo,
      instrumentalActivityOfDailyLiving: updateInstrumentalInfo,
      attendantProfile: updateAttendantInfo,
      socialProfile: updateSocialInfo,
      financialProfile: updateFinancialInfo,
      additionalInformation: additionalInfo,
    };

    console.log("params", params);
    axios
      .post(ClientURL.SAVE_NURSING_ASSESSMENT, params, {
        headers: { Authorization: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          AgencyStore.showAlert(
            "success",
            "Successfully Saved Nursing Assessment Records"
          );
          ClientStore.setNursingAssessRecord(res?.data?.result);
          AgencyStore.setIsLoading(false);
          AgencyStore.setIsSaveLoading(true);
          handleClose();
        } else if (res?.data?.status == "failed") {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", res?.data?.message);
        } else {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert(
            "error",
            "Failed to Saved Nursing Assessment Records"
          );
        }
      })
      .catch((err) => {
        AgencyStore.setIsLoading(false);
        AgencyStore.showAlert(
          "error",
          "Failed to Saved Nursing Assessment Records"
        );
      });
  };

  return (
    <>
      <div className="homeSafetyContainer">
        <div className="underlineClick" onClick={handleClose}>
          Back
        </div>
        <div className="safetySelectInput">
          <div>Visit Type:</div>
          <div className="clientListinputFiled">
            <FormikController
              control="selects"
              error
              selectitem={nurseVisitType}
              {...formik.getFieldProps("visitType")}
              touch={formik.touched.visitType}
              errorname={formik.errors.visitType}
            />
          </div>
        </div>
      </div>

      <div className="medicationWrapper">
        <div className="medicationSection">
          <div className="heading">NURSING ASSESSMENT*</div>

          <div className="detailWrapper">
            <Grid container spacing={2} pb={3}>
              <Grid item xs={5} className="rowSection">
                <div className="nameList">Client's Name:</div>
                <div className="medicationForm">
                  <FormikController
                    value={
                      ClientStore.ClientAllData.client?.firstName +
                      "  " +
                      ClientStore.ClientAllData.client?.lastName
                    }
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={3} className="rowSection">
                <div className="nameList">DOB:</div>
                <div className="medicationForm">
                  <FormikController
                    value={ClientStore.ClientAllData.client?.dateOfBirth}
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={4} className="rowSection">
                <div className="nameList">Client Phone:</div>
                <div className="medicationForm">
                  <FormikController
                    value={ClientStore.ClientAllData.client?.phoneNo}
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameList">RN Name:</div>
                <div className="medicationForm">
                  <FormikController
                    control="selectByInput"
                    options={relationRN}
                    handleChange={(event, value) => {
                      formik.setFieldValue(
                        "relationRN",
                        value ? value.value : ""
                      );
                      // setRnFullName(value.label);
                    }}
                    // values={rnFullName}
                    touch={formik.touched.relationRN}
                    errorname={formik.errors.relationRN}
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Client's Address:</div>
                <div className="medicationForm">
                  <FormikController
                    value={
                      ClientStore.ClientAllData.client.clientAddress?.street +
                      "  " +
                      ClientStore.ClientAllData.client.clientAddress?.city +
                      "  " +
                      ClientStore.ClientAllData.client.clientAddress?.state +
                      "  " +
                      ClientStore.ClientAllData.client.clientAddress?.zipCode
                    }
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Doctor Name:</div>
                <div className="medicationForm">
                  <FormikController
                    variant="standard"
                    control="textfield"
                    type="text"
                    {...formik.getFieldProps("doctorName")}
                    touch={formik.touched.doctorName}
                    errorname={formik.errors.doctorName}
                  />
                </div>
              </Grid>
              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Doctor Phone:</div>
                <div className="medicationForm">
                  <FormikController
                    variant="standard"
                    control="textfield"
                    {...formik.getFieldProps("doctorPhoneNo")}
                    touch={formik.touched.doctorPhoneNo}
                    errorname={formik.errors.doctorPhoneNo}
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Contact Person:</div>
                <div className="medicationForm">
                  <FormikController
                    variant="standard"
                    control="textfield"
                    {...formik.getFieldProps("contactPerson")}
                    touch={formik.touched.contactPerson}
                    errorname={formik.errors.contactPerson}
                  />
                </div>
              </Grid>

              <Grid item xs={6} className="rowSection">
                <div className="nameDesc">Contact Phone:</div>
                <div className="medicationForm">
                  <FormikController
                    variant="standard"
                    control="textfield"
                    {...formik.getFieldProps("contactPhoneNo")}
                    touch={formik.touched.contactPhoneNo}
                    errorname={formik.errors.contactPhoneNo}
                  />
                </div>
              </Grid>
            </Grid>

            <TableContainer>
              <Table className="table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className="tablecell" colSpan={3}>
                      NURSING ASSESSMENT
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="tablecell" sx={headerTextStyles}>
                      General Topics
                    </TableCell>
                    <TableCell className="tablecell" sx={headerTextStyles}>
                      Subject Matter
                    </TableCell>
                    <TableCell className="tablecell" sx={headerTextStyles}>
                      Action(S) Indicated
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      Medical Information
                    </TableCell>
                  </TableRow>
                  {medicalInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.subjectMatter}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleChange(
                                index,
                                e.target.value,
                                "subjectMatter",
                                setMedicalInfo
                              )
                            }
                          />
                        </TableCell>
                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleChange(
                                index,
                                e.target.value,
                                "actionIndicated",
                                setMedicalInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      Systems Assessment
                    </TableCell>
                  </TableRow>
                  {systemAssessInfo?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Vital Signs" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    <div key={subIndex} className="textForm">
                                      Temperature::{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Vital Signs",
                                            subIndex,
                                            "temperature",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    Pulse:
                                    {key?.pulse?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "pulse"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "pulse",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Respirations:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Vital Signs",
                                            subIndex,
                                            "respirations",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    B/P:
                                    {key?.bp?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "bp"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange("bp", subKey)
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Neurological" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Orientation:
                                    {key?.orientation?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "orientation"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "orientation",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Pupils
                                    {key?.pupils?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "pupils"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "pupils",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Neurological",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                    Grip:
                                    {key?.grip?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "grip"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "grip",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Integumentary" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Skin:
                                    {key?.skin?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "skin"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "skin",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Oral membranes:
                                    {key?.oralMembranes?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "oralMembranes"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "oralMembranes",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Cardiovascular" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Peripheral
                                    {key?.peripheral?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "peripheral"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "peripheral",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    {/* <div key={subIndex} className="textForm">
                                      Sensation:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Cardiovascular",
                                            subIndex,
                                            "sensation",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Sensation:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Cardiovascular",
                                            subIndex,
                                            "sensation",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      {"Capillary refill[>, < 3-5sec]: "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                      
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Cardiovascular",
                                            subIndex,
                                            "capillary",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Cyanosis:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Cardiovascular",
                                            subIndex,
                                            "cyanosis",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div> */}
                                    Edema
                                    {key?.edema?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "edema"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "edema",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Location of edema:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Cardiovascular",
                                            subIndex,
                                            "locationEdema",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Respiratory" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.respiratory?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "respiratory"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "respiratory",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Oxygen:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Respiratory",
                                            subIndex,
                                            "oxygen",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Musculoskeletal" ? (
                            <div>
                              {item?.subjectMatter[0]?.musculoskeletal?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "musculoskeletal"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "musculoskeletal",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Gastrointestinal" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Abdomen:
                                    {key?.abdomen?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "abdomen"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "abdomen",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Pain:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Gastrointestinal",
                                            subIndex,
                                            "pain",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                      Last BM:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Gastrointestinal",
                                            subIndex,
                                            "lastBM",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Genitourinary" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.genitourinary?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "genitourinary"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "genitourinary",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      size:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Gastrointestinal",
                                            subIndex,
                                            "size",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                      Color:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Gastrointestinal",
                                            subIndex,
                                            "color",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                      Last changed:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Gastrointestinal",
                                            subIndex,
                                            "LastChanged",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Pain" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.pain?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "pain"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "pain",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <FormikController
                                      control="textfield"
                                      variant="standard"
                                      onChange={(e) =>
                                        handleTextChange(
                                          "Pain",
                                          subIndex,
                                          "painLevel",
                                          e.target.value,
                                          setSystemAssessInfo
                                        )
                                      }
                                    />
                                    <div key={subIndex} className="textForm">
                                      Location:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Pain",
                                            subIndex,
                                            "location",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Onset:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Pain",
                                            subIndex,
                                            "onset",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Duration:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Pain",
                                            subIndex,
                                            "duration",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Pain description:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Pain",
                                            subIndex,
                                            "painDescription",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Pain relief:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Pain",
                                            subIndex,
                                            "painRelief",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Medications" ? (
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.subjectMatter}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  e.target.value,
                                  "subjectMatter",
                                  setSystemAssessInfo
                                )
                              }
                            />
                          ) : item.generalTopic == "Medication Allergies" ? (
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.subjectMatter}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  e.target.value,
                                  "subjectMatter",
                                  setSystemAssessInfo
                                )
                              }
                            />
                          ) : item.generalTopic == "Current Treatments" ? (
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.subjectMatter}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  e.target.value,
                                  "subjectMatter",
                                  setSystemAssessInfo
                                )
                              }
                            />
                          ) : item.generalTopic == "Current Therapy" ? (
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.subjectMatter}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  e.target.value,
                                  "subjectMatter",
                                  setSystemAssessInfo
                                )
                              }
                            />
                          ) : item.generalTopic == "Dental Care" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Does Client have dental problems?
                                    {key?.dentalProblems?.map((subKey) => {
                                      return (
                                        <div>
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.dentalProblems.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "dentalProblems",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Is Client under care of Dentist?
                                    {key?.underCaredentist?.map((subKey) => {
                                      return (
                                        <div>
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.underCaredentist.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "underCaredentist",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Dental State:
                                    {key?.dentalState?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "dentalState"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "dentalState",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Dental Care",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    Can Client chew food effectively?
                                    {key?.chewfood?.map((subKey) => {
                                      return (
                                        <div>
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.chewfood.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "chewfood",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Dentist’ Name{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Dental Care",
                                            subIndex,
                                            "dentistName",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      {" "}
                                      Dentist’s Phone Number:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Dental Care",
                                            subIndex,
                                            "dentistPhone",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Vision" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.vision?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "vision"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "vision",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Wears Glasses:
                                    {key?.wearGlasses?.map((subKey) => {
                                      return (
                                        <div>
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.wearGlasses.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "wearGlasses",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Vision",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Hearing" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.hearing?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "hearing"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "hearing",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Uses Hearing Aid(s):
                                    {key?.useHearing?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "useHearing"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "useHearing",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Psychosocial" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.pyschosocial?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "pyschosocial"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "pyschosocial",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Psychosocial",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setSystemAssessInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Attitude:
                                    {key?.attitude?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "attitude"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "attitude",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Appearance:
                                    {key?.appearance?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "appearance"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "appearance",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Self-Direction:
                                    {key?.selfDirection?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "selfDirection"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "selfDirection",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Behavior:
                                    {key?.behavior?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "behavior"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "behavior",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Influence :
                                    {key?.influence?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "influence"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "influence",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Thought Content:
                                    {key?.attitude?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "thoughtContent"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "thoughtContent",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Perceptions:
                                    {key?.perceptions?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "perceptions"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "perceptions",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Cognition:
                                    {key?.cognition?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "cognition"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "cognition",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Insight:
                                    {key?.insight?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "insight"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "insight",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Judgment:
                                    {key?.judgment?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "judgment"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "judgment",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setSystemAssessInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      LIVING HABITS
                    </TableCell>
                  </TableRow>
                  {livingInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Smoking Habits" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Client Smokes:
                                    {key?.clientSmoke?.map((subKey) => {
                                      return (
                                        <div className="radioButonForm">
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.clientSmoke.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "clientSmoke",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Degree of Problem:
                                    {key?.degreeOfProblem?.map((subKey) => {
                                      return (
                                        <div className="radioButonForm">
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.degreeOfProblem.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "degreeOfProblem",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Alcohol Consumption" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Client Drinks :
                                    {key?.clientDrink?.map((subKey) => {
                                      return (
                                        <div className="radioButonForm">
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.clientDrink.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "clientDrink",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Degree of Problem:
                                    {key?.degreeOfProblemAlcohol?.map(
                                      (subKey) => {
                                        return (
                                          <div className="radioButonForm">
                                            <FormControlLabel
                                              control={
                                                <Radio
                                                  value={subKey}
                                                  checked={selectOption.degreeOfProblemAlcohol.includes(
                                                    subKey
                                                  )}
                                                  onChange={() =>
                                                    handleRadioChange(
                                                      "degreeOfProblemAlcohol",
                                                      subKey
                                                    )
                                                  }
                                                />
                                              }
                                            />
                                            {subKey}
                                          </div>
                                        );
                                      }
                                    )}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Current Diet" ? (
                            <>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.currentDiet?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "currentDiet"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "currentDiet",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Others:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Current Diet",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setLivingInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : item.generalTopic == "Allergies: Food & Other" ? (
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.actionIndicated}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  e.target.value,
                                  "subjectMatter",
                                  setLivingInfo
                                )
                              }
                            />
                          ) : (
                            <>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.eating?.map((subKey) => {
                                      return (
                                        <div className="radioButonForm">
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.eating.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "eating",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Comments:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Eating Habits (appetite)",
                                            subIndex,
                                            "comments",
                                            e.target.value,
                                            setLivingInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setLivingInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      COMMUNICATION
                    </TableCell>
                  </TableRow>
                  {communications?.map((item, index) => {
                    if (item.generalTopic === "Language Spoken") {
                      return (
                        <TableRow key={index}>
                          <TableCell className="tablecell">
                            {item.generalTopic}
                          </TableCell>
                          <TableCell className="tablecell">
                            {item?.subjectMatter?.map((key, subIndex) => {
                              return (
                                <>
                                  {key?.spokenLanguage?.map((subKey) => {
                                    return (
                                      <div className="textForm">
                                        <input
                                          type="checkbox"
                                          checked={selectedValues[
                                            "spokenLanguage"
                                          ]?.includes(subKey)}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              "spokenLanguage",
                                              subKey
                                            )
                                          }
                                        />
                                        {subKey}
                                      </div>
                                    );
                                  })}
                                  <div key={subIndex} className="textForm">
                                    Others:{" "}
                                    <FormikController
                                      control="textfield"
                                      variant="standard"
                                      onChange={(e) =>
                                        handleTextChange(
                                          "Language Spoken",
                                          subIndex,
                                          "others",
                                          e.target.value,
                                          setCommunication
                                        )
                                      }
                                    />
                                  </div>
                                </>
                              );
                            })}
                          </TableCell>

                          <TableCell className="tablecell">
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleTextChange(
                                  "Language Spoken",
                                  0,
                                  "actionIndicated",
                                  e.target.value,
                                  setCommunication
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      );
                    } else if (item.generalTopic === "Speech") {
                      return (
                        <TableRow key={index}>
                          <TableCell className="tablecell">
                            {item.generalTopic}
                          </TableCell>
                          <TableCell className="tablecell">
                            {item?.subjectMatter?.map((key, subIndex) => {
                              return (
                                <>
                                  {key?.underStandableSpeech?.map((subKey) => {
                                    return (
                                      <div className="textForm">
                                        <input
                                          type="checkbox"
                                          checked={selectedValues[
                                            "underStandableSpeech"
                                          ]?.includes(subKey)}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              "underStandableSpeech",
                                              subKey
                                            )
                                          }
                                        />
                                        {subKey}
                                      </div>
                                    );
                                  })}
                                  <div key={subIndex} className="textForm">
                                    If Client Cannot Speak, Indicate Method of
                                    Communicating::
                                    <FormikController
                                      control="textfield"
                                      variant="standard"
                                      onChange={(e) =>
                                        handleTextChange(
                                          "Speech",
                                          subIndex,
                                          "clientSpeak",
                                          e.target.value,
                                          setCommunication
                                        )
                                      }
                                    />
                                  </div>
                                  {key?.method?.map((subKey) => {
                                    return (
                                      <div className="textForm">
                                        <input
                                          type="checkbox"
                                          checked={selectedValues[
                                            "method"
                                          ]?.includes(subKey)}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              "method",
                                              subKey
                                            )
                                          }
                                        />
                                        {subKey}
                                      </div>
                                    );
                                  })}
                                </>
                              );
                            })}
                          </TableCell>
                          <TableCell className="tablecell">
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.actionIndicated}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleTextChange(
                                  "Speech",
                                  0,
                                  "actionIndicated",
                                  e.target.value,
                                  setCommunication
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      );
                    } else {
                      return (
                        <TableRow key={index}>
                          <TableCell className="tablecell">
                            {item.generalTopic}
                          </TableCell>
                          <TableCell className="tablecell">
                            {item?.subjectMatter?.map((key, subIndex) => {
                              return (
                                <>
                                  {key?.phrases?.map((subKey) => {
                                    return (
                                      <div className="textForm">
                                        <input
                                          type="checkbox"
                                          checked={selectedValues[
                                            "phrases"
                                          ]?.includes(subKey)}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              "phrases",
                                              subKey
                                            )
                                          }
                                        />
                                        {subKey}
                                      </div>
                                    );
                                  })}
                                </>
                              );
                            })}
                          </TableCell>
                          <TableCell className="tablecell">
                            <FormikController
                              control="textfield"
                              variant="standard"
                              multiline
                              rows={3}
                              // value={item.actionIndicated}
                              InputProps={{
                                disableUnderline: true,
                              }}
                              onChange={(e) =>
                                handleTextChange(
                                  "Understanding",
                                  0,
                                  "actionIndicated",
                                  e.target.value,
                                  setCommunication
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      ACTIVITIES OF DAILY LIVING
                    </TableCell>
                  </TableRow>
                  {dailyInfo?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Mobility Aids" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.mobility?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "mobility"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "mobility",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Uses Wheelchair:
                                    {key?.wheelChair?.map((subKey) => {
                                      return (
                                        <div className="radioButonForm">
                                          <FormControlLabel
                                            control={
                                              <Radio
                                                value={subKey}
                                                checked={selectOption.wheelChair.includes(
                                                  subKey
                                                )}
                                                onChange={() =>
                                                  handleRadioChange(
                                                    "wheelChair",
                                                    subKey
                                                  )
                                                }
                                              />
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other Prosthesis Or Aid:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Mobility Aids",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Comment:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Mobility Aids",
                                            subIndex,
                                            "comments",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Ambulation" ? (
                            <div>
                              {item?.subjectMatter[0]?.ambulation?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "ambulation"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "ambulation",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Transferring" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.independent?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "independent"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "independent",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Needs Supervision transferring to :
                                    {key?.supervisionTransferring?.map(
                                      (subKey) => {
                                        return (
                                          <div className="textForm">
                                            <input
                                              type="checkbox"
                                              checked={selectedValues[
                                                "supervisionTransferring"
                                              ]?.includes(subKey)}
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  "supervisionTransferring",
                                                  subKey
                                                )
                                              }
                                            />
                                            {subKey}
                                          </div>
                                        );
                                      }
                                    )}
                                    Needs Intermittent Assistance transferring
                                    to:
                                    {key?.intermittentTransferring?.map(
                                      (subKey) => {
                                        return (
                                          <div className="textForm">
                                            <input
                                              type="checkbox"
                                              checked={selectedValues[
                                                "intermittentTransferring"
                                              ]?.includes(subKey)}
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  "intermittentTransferring",
                                                  subKey
                                                )
                                              }
                                            />
                                            {subKey}
                                          </div>
                                        );
                                      }
                                    )}
                                    Needs Continued Assistance transferring to :
                                    {key?.continuedAssistance?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "continuedAssistance"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "continuedAssistance",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Bathing" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.bathing?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "bathing"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "bathing",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Requires Minor Assistance or Supervision:
                                    {key?.minorSupervision?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "minorSupervision"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "minorSupervision",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Bathing",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Dressing" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.independents?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "independents"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "independents",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Supervision or Needs some help:
                                    {key?.supervision?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "supervision"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "supervision",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Periodic or Daily Help Needed:
                                    {key?.dailyHelp?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "dailyHelp"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "dailyHelp",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Grooming & Hygiene" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.grooming?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "grooming"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "grooming",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Requires Assistance with Some Things
                                    {key?.assistance?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "assistance"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "assistance",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Eating" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.eating?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "eating"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "eating",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    Requires Intermittent Help With:
                                    {key?.intermittent?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "intermittent"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "intermittent",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Bladder Control" ? (
                            <div>
                              {item?.subjectMatter[0]?.bladder?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "bladder"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange("bladder", key)
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Bowel Control" ? (
                            <div>
                              {item?.subjectMatter[0]?.bowelControl?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "bowelControl"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "bowelControl",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Toileting" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.toileting?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "toileting"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "toileting",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Other :{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Toileting",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    Exercises Regularly:
                                    {key?.exercisesRegularly?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "exercisesRegularly"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "exercisesRegularly",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}
                                    <div key={subIndex} className="textForm">
                                      Other :{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Exercising",
                                            subIndex,
                                            "other",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                    <div key={subIndex} className="textForm">
                                      Time and/or Distance: :{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Exercising",
                                            subIndex,
                                            "time",
                                            e.target.value,
                                            setDailyInfo
                                          )
                                        }
                                      />
                                    </div>
                                    Recent Changes to Exercise Regime:
                                    {key?.recentChangesToExercise?.map(
                                      (subKey) => {
                                        return (
                                          <div className="textForm">
                                            <input
                                              type="checkbox"
                                              checked={selectedValues[
                                                "recentChangesToExercise"
                                              ]?.includes(subKey)}
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  "recentChangesToExercise",
                                                  subKey
                                                )
                                              }
                                            />
                                            {subKey}
                                          </div>
                                        );
                                      }
                                    )}
                                  </>
                                );
                              })}
                            </div>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setDailyInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      INSTRUMENTAL ACTIVITIES OF DAILY LIVING
                    </TableCell>
                  </TableRow>

                  {instrumentalInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Preparing Food" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.prepareFood?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "prepareFood"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "prepareFood",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Note to Prepare Food:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Preparing Food",
                                            subIndex,
                                            "notes",
                                            e.target.value,
                                            setInstrumentalInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Housekeeping" ? (
                            <div>
                              {item?.subjectMatter[0]?.housekeeping?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "housekeeping"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "housekeeping",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Shopping" ? (
                            <div>
                              {item?.subjectMatter[0]?.shopping?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "shopping"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange("shopping", key)
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Transportation" ? (
                            <div>
                              {item?.subjectMatter[0]?.transportation?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "transportation"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "transportation",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : item.generalTopic == "Telephone" ? (
                            <div>
                              {item?.subjectMatter[0]?.telephone?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "telephone"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange("telephone", key)
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : (
                            <div>
                              {item?.subjectMatter[0]?.medication?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "medication"
                                        ]?.includes(key)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "medication",
                                            key
                                          )
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setInstrumentalInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      ATTENDANT PROFILE
                    </TableCell>
                  </TableRow>
                  {attendantInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>

                        <TableCell className="tablecell">
                          {item?.subjectMatter?.map((key, subIndex) => {
                            return (
                              <>
                                {key?.attendant?.map((subKey) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "attendant"
                                        ]?.includes(subKey)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "attendant",
                                            subKey
                                          )
                                        }
                                      />
                                      {subKey}
                                    </div>
                                  );
                                })}
                                Frequency of Attendant Assistance:
                                {key?.frequency?.map((subKey) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "frequency"
                                        ]?.includes(subKey)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "frequency",
                                            subKey
                                          )
                                        }
                                      />
                                      {subKey}
                                    </div>
                                  );
                                })}
                                Attendant Needs Met by:
                                {key?.attendantMeetBy?.map((subKey) => {
                                  return (
                                    <div className="textForm">
                                      <input
                                        type="checkbox"
                                        checked={selectedValues[
                                          "attendantMeetBy"
                                        ]?.includes(subKey)}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            "attendantMeetBy",
                                            subKey
                                          )
                                        }
                                      />
                                      {subKey}
                                    </div>
                                  );
                                })}
                                <div key={subIndex} className="textForm">
                                  Other:
                                  <FormikController
                                    control="textfield"
                                    variant="standard"
                                    onChange={(e) =>
                                      handleTextChange(
                                        "Attendant",
                                        subIndex,
                                        "others",
                                        e.target.value,
                                        setAttendantInfo
                                      )
                                    }
                                  />
                                </div>
                              </>
                            );
                          })}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setAttendantInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      SOCIAL PROFILE
                    </TableCell>
                  </TableRow>
                  {socialInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Housing" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.housing?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "housing"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "housing",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Other:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Housing",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setSocialInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Living Companions" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.livingCompanion?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "livingCompanion"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "livingCompanion",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Principal Helper:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Living Companions",
                                            subIndex,
                                            "principalHelper",
                                            e.target.value,
                                            setSocialInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : (
                            <>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <div key={subIndex}>
                                    {Object.keys(key).map(
                                      (field, innerIndex) => {
                                        return (
                                          <div
                                            key={innerIndex}
                                            className="textForm"
                                          >
                                            {field == "ethnicity"
                                              ? "Ethnicity:"
                                              : "Religions:"}

                                            <FormikController
                                              control="textfield"
                                              variant="standard"
                                              onChange={(e) =>
                                                handleTextChange(
                                                  "Religion & Culture",
                                                  subIndex,
                                                  field,
                                                  e.target.value,
                                                  setSocialInfo
                                                )
                                              }
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setSocialInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      FINANCIAL PROFILE
                    </TableCell>
                  </TableRow>
                  {financialInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          {item.generalTopic}
                        </TableCell>
                        <TableCell className="tablecell">
                          {item.generalTopic == "Financial Benefits" ? (
                            <div>
                              Financial Benefits:
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.financialBenefits?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "financialBenefits"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "financialBenefits",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Others:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Financial Benefits",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setFinancialInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : item.generalTopic == "Financial Management" ? (
                            <div>
                              {item?.subjectMatter?.map((key, subIndex) => {
                                return (
                                  <>
                                    {key?.financialMgmt?.map((subKey) => {
                                      return (
                                        <div className="textForm">
                                          <input
                                            type="checkbox"
                                            checked={selectedValues[
                                              "financialMgmt"
                                            ]?.includes(subKey)}
                                            onChange={() =>
                                              handleCheckboxChange(
                                                "financialMgmt",
                                                subKey
                                              )
                                            }
                                          />
                                          {subKey}
                                        </div>
                                      );
                                    })}

                                    <div key={subIndex} className="textForm">
                                      Others:{" "}
                                      <FormikController
                                        control="textfield"
                                        variant="standard"
                                        onChange={(e) =>
                                          handleTextChange(
                                            "Financial Benefits",
                                            subIndex,
                                            "others",
                                            e.target.value,
                                            setFinancialInfo
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          ) : (
                            <>
                              {item?.subjectMatter[0]?.approx?.map(
                                (key, subIndex) => {
                                  return (
                                    <div className="radioButonForm">
                                      <FormControlLabel
                                        control={
                                          <Radio
                                            value={key}
                                            checked={selectOption.approx.includes(
                                              key
                                            )}
                                            onChange={() =>
                                              handleRadioChange("approx", key)
                                            }
                                          />
                                        }
                                      />
                                      {key}
                                    </div>
                                  );
                                }
                              )}
                            </>
                          )}
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleTextChange(
                                item.generalTopic,
                                0,
                                "actionIndicated",
                                e.target.value,
                                setFinancialInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  <TableRow>
                    <TableCell
                      className="tablecell"
                      colSpan={3}
                      sx={centerTextStyles}
                    >
                      ADDITIONAL INFORMATION
                    </TableCell>
                  </TableRow>
                  {additionalInfo.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleChange(
                                index,
                                e.target.value,
                                "generalTopic",
                                setAdditionalInfo
                              )
                            }
                          />
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleChange(
                                index,
                                e.target.value,
                                "subjectMatter",
                                setAdditionalInfo
                              )
                            }
                          />
                        </TableCell>

                        <TableCell className="tablecell">
                          <FormikController
                            control="textfield"
                            variant="standard"
                            multiline
                            rows={3}
                            // value={item.actionIndicated}
                            InputProps={{
                              disableUnderline: true,
                            }}
                            onChange={(e) =>
                              handleChange(
                                index,
                                e.target.value,
                                "actionIndicated",
                                setAdditionalInfo
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <div>
              <div>Time In</div>
              <div>Time Out</div>
            </div> */}
          </div>
          <Grid container spacing={2}>
            <div className="formButtonSave">
              <ConfirmPopUp
                buttonLabel={type == "save" ? "Save " : "Update"}
                title={type == "save" ? "Save " : "Update"}
                content=" Please confirm your decision below."
                onConfirm={() => {
                  if (type == "save") {
                    handlesaveUpadateState("save");
                  }
                  // else {
                  //   handlesaveUpadateState("update");
                  // }
                  formik.handleSubmit();
                }}
                clickHTML={
                  <FormikController
                    control="buttons"
                    name={
                      type == "save"
                        ? "Save Nursing Assessment"
                        : "UPDATE Nursing Assessment"
                    }
                    className="buttonSelectedGreen fixedWidth"
                    fullWidth="false"
                  />
                }
              />
            </div>
          </Grid>
        </div>
      </div>
    </>
  );
};
